import { CollectionInfoModel } from "@phdsoft/common";
import { Collection } from "./Collection";

export class ProtectionElementsCampaign extends Collection {
  private _insertionMethod: string;

  public get insertionMethod(): string {
    return this._insertionMethod;
  }
  public set insertionMethod(value: string) {
    this._insertionMethod = value;
  }

  private _elementName: string;

  public get elementName(): string {
    return this._elementName;
  }
  public set elementName(value: string) {
    this._elementName = value;
  }

  constructor(date: Date, collectionInfoModel: CollectionInfoModel, elementName: string, insertionMethod: string) {
    super(date);
    this.Type = 'ProtectionElementsCampaign';
    this.elementName = elementName
    this.insertionMethod = insertionMethod

    this.CollectionInfoModel = collectionInfoModel
  }
}
